export default __webpack_public_path__ + "static/mbp-bdbcf52a337a07f23eb7bf819b14b2e7.png";